<template>
  <!-- Modal terms -->
  <div
    class="modal fade show"
    id="free-promotion-applied"
    tabindex="-1"
    role="dialog"
    aria-labelledby="freePromotionModal"
    aria-hidden="false"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="freePromotionModal">{{ $t('Ücretsiz Hizmet Bilgilendirmesi') }}</h4>
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
        </div>
        <div class="modal-body modal-body-min">
          <p>{{ $t('Ücretsiz Hizmet Bilgilendirmesi text') }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn_1" data-dismiss="modal">{{ $t('Kapat') }}</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
    <a id="freeSubscription" href="#" data-toggle="modal" data-target="#free-promotion-applied"></a>
  </div>
  <!-- /.modal -->
</template>
<script>
export default {
  name: 'FreePromotionApplied',
};
</script>
